import Button from 'components/UI/Button';
import { Section, CTATitle, CTAButtons } from './styles/CTA.styles';
import { Highlight } from './styles/Testimonials.styles';
import getAuthToken from 'utils/cookie';
import { useNavigate } from 'react-router-dom';
export default function CTASection() {
  const navigate = useNavigate();
  const signUpClickHandler = () => {
    const tokenValue = getAuthToken();
    if (tokenValue) {
      navigate(`/coverage/#id_token=${tokenValue}`);
    } else {
      navigate('/signup', { state: { prevLandingPage: true } });
    }
  };
  return (
    <Section>
      <CTATitle>
        Read Smarter.{' '}
        <Highlight>
          Develop <br className="cta-br" /> Faster
        </Highlight>
        .
      </CTATitle>
      <CTAButtons>
        <Button
          element="link"
          to="https://calendly.com/fullframe-support/30min?month=2023-09"
          className="orange-outline-btn">
          Request Demo
        </Button>
        <button onClick={signUpClickHandler} className="gradient-orange-btn">
          Start Coverage Now
        </button>
      </CTAButtons>
    </Section>
  );
}
